'use strict';

var react = require('@emotion/react');

const pillGroup = /*#__PURE__*/ react.css({
    display: "flex",
    gap: "4px"
}, "label:label-PillGroup-web-stylespillGroup", "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2lhbmNsYXJrZS9kZXYvYXZpYXJ5L3BhY2thZ2VzL2F2aWFyeS13ZWIvc3JjL2NvbXBvbmVudHMvbW9sZWN1bGVzL1BpbGxHcm91cC9QaWxsR3JvdXAud2ViLnN0eWxlcy50cyIsInNvdXJjZXMiOlsiL1VzZXJzL2lhbmNsYXJrZS9kZXYvYXZpYXJ5L3BhY2thZ2VzL2F2aWFyeS13ZWIvc3JjL2NvbXBvbmVudHMvbW9sZWN1bGVzL1BpbGxHcm91cC9QaWxsR3JvdXAud2ViLnN0eWxlcy50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBjc3MgfSBmcm9tIFwiQGVtb3Rpb24vcmVhY3RcIjtcblxuZXhwb3J0IGNvbnN0IHBpbGxHcm91cCA9IGNzcyh7XG4gIGRpc3BsYXk6IFwiZmxleFwiLFxuICBnYXA6IFwiNHB4XCIsXG59KTtcbiJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFeUIifQ== */");

exports.pillGroup = pillGroup;
//# sourceMappingURL=PillGroup.web.styles.cjs.map
